<template>
    <span>

        <a-popover v-model="visible" title="选择颜色" trigger="click">
            <div slot="content">
                <div :style="{'background':choseColor,'height':'20px'}"></div>
                <sketch-picker
                    :value="colors"
                    @input="updateValue"
                    :disableAlpha="true"
                ></sketch-picker>
                <div style="margin-top: 5px;">
                    <a-space>
                        <a-button @click="cancel" size="small">取消</a-button>
                        <a-button @click="ok" size="small" type="primary">确定</a-button>
                    </a-space>
                </div>
            </div>
            <button @click="show()" class="color-button" :style="{'background':currentColor}"></button>
          </a-popover>

    </span>

</template>

<script>
import {Sketch} from 'vue-color'

export default {
    name: "ColorChose",
    components: {
        'sketch-picker': Sketch
    },
    props: {
        colors: {
            type: String,
        }
    },
    data() {
        return {
            visible: false,
            choseColor: this.colors,
            currentColor: this.colors
        }
    },
    methods: {
        show() {
            this.visible = !this.visible
        },
        updateValue(value) {
            this.choseColor = value.hex
            this.currentColor = this.choseColor
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.$emit('chose', this.currentColor)
            }, 40)
        },
        ok() {
            this.visible = false;
        },
        cancel() {
            this.visible = false;
        }
    }
}
</script>

<style scoped>
.color-button {
    width: 26px;
    height: 26px;
    border: none;
}

.color-button:hover {
    cursor: pointer;
}
</style>
